// @flow
/* eslint-disable @gandi/gandi/no-global-element */

import * as React from 'react';

import { useDispatch } from 'react-redux';

import {
  checkSmdFileValidity,
  selectSmdFileInfos,
  type DomainProduct,
} from '@gandi/cart';
import { notifyDanger } from '@gandi/notifications';
import { useTranslator } from '@gandi/translate';

import { Form } from 'gandi.react-form';

import ListSpinner from 'src/components/ListSpinner';
import { useAppSelector } from 'src/hooks/useAppSelector';

import type { SmdFileInfo } from '../types';

import FileInfo from './FileInfo';

type Props = {
  checking: boolean,
  product: DomainProduct,
  setChecking: boolean => void,
  removedByUser: boolean,
  setRemovedByUser: boolean => void,
};

export default function SmdForm({
  checking,
  product,
  setChecking,
  removedByUser,
  setRemovedByUser,
}: Props): React.Node {
  const translator = useTranslator();
  const { __ } = translator;

  // FIXME: move SmdFileInfo type to cart
  // $FlowFixMe[incompatible-type]
  const smdFileInfos: void | SmdFileInfo = useAppSelector(state =>
    selectSmdFileInfos(state, { fqdn: product.fqdn }),
  );

  const dispatch = useDispatch();

  return (
    <>
      {checking && <ListSpinner message={__('Checking SMD file ...')} />}
      {!checking && (removedByUser || !smdFileInfos?.isValid) && (
        <>
          <h3>{__('Upload the corresponding SMD file')}</h3>
          <Form
            method="post"
            onSubmit={(evt: SyntheticEvent<HTMLFormElement>) =>
              evt.preventDefault()
            }
            noValidate
            style={{ marginBottom: smdFileInfos?.isValid ? 'none' : '10px' }}
          >
            {
              // we have to embed the <input> into <div>
              // to avoid csrf hydratation bug
            }
            <div>
              <input
                id="smdFile"
                name="smdFile"
                onChange={async (
                  evt: SyntheticInputEvent<HTMLInputElement>,
                ) => {
                  setChecking(true);
                  try {
                    const file = evt.target.files[0];
                    await dispatch(checkSmdFileValidity(product, file));
                    setRemovedByUser(false);
                  } catch (error) {
                    dispatch(notifyDanger(__('Unexpected error occurred')));
                  }
                  setChecking(false);
                }}
                type="file"
                accept=".smd"
              />
            </div>
          </Form>
        </>
      )}
      {!checking && (!removedByUser || !smdFileInfos?.isValid) && (
        <FileInfo
          fqdn={product.fqdn || ''}
          setRemovedByUser={setRemovedByUser}
        />
      )}
    </>
  );
}
